import { useState, useEffect } from "react";
import { Box, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import MIFieldsDrawer from "./MIFieldsDrawer";
import DataService from "../../../../../Service";
import SetupAutoComplete from "../SetupAutoComplete";

const ManagementInformation = () => {
  const [orgData, setorgData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(100);
  const [currentSelection, setCurrentSelection] = useState({});
  const [drawer, setDrawer] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchOrgInfo();
  }, [pageSize, page, searchText]);

  const fetchOrgInfo = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: searchText,
    };
    setTableLoading(true);

    DataService.getData(params, "miFieldsOrganisationList")
      .then((res) => {
        if (res?.success) {
          setorgData(res?.organisations);
          setTotalCount(res?.total_count);
        }
      })
      .catch((error) => {})
      .finally(() => {
        setTableLoading(false);
      });
  };
  const searchSelectHandler = (option) => {
    setSearchText(option);
    setPage(0);
  };
  return (
    <Box mb={3}>
      <SetupAutoComplete
        type={"management_information"}
        searchSelectHandler={searchSelectHandler}
      />
      <MaterialTable
        title=""
        options={{
          search: false,
          actionsColumnIndex: -1,
          pageSize: pageSize,
          emptyRowsWhenPaging: false,
          maxBodyHeight: "600px",
          pageSizeOptions: [20, 50, 75, 100],
        }}
        columns={[
          {
            title: "Client name",
            field: "organisation_name",
            type: "string",
            emptyValue: "-",
            customSort: (a, b) => {
              const nameA = a.organisation_name.toLowerCase();
              const nameB = b.organisation_name.toLowerCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            },
          },
          {
            title: "Account manager name",
            field: "account_managers",
            render: (rowData) => {
              return rowData.account_managers.join(" , ");
            },
            type: "string",
            emptyValue: "-",
          },
          {
            title: "Coordinator name",
            field: "coaching_coordinators",
            type: "string",
            emptyValue: "-",
            render: (rowData) => {
              return rowData.coaching_coordinators.join(" , ");
            },
          },
        ]}
        data={orgData}
        totalCount={totalCount}
        page={page}
        onRowClick={(e, rowData) => {
          setCurrentSelection(rowData);
        }}
        onChangePage={(page) => {
          setPage(page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          setPageSize(pageSize);
        }}
        isLoading={tableLoading}
        actions={[
          {
            icon: () => (
              <Tooltip
                title={<TooltipWrapper text="View" />}
                children={<VisibilityIcon fontSize="small" />}
              />
            ),

            onClick: (event, rowData) => {
              setDrawer(true);
              setCurrentSelection(rowData);
            },
          },
        ]}
      />

      {drawer && (
        <MIFieldsDrawer
          parentCall={setDrawer}
          currentSelection={currentSelection}
        />
      )}
    </Box>
  );
};

export default ManagementInformation;
